import { luhnCheck } from './../helpers/validation-helpers';

const credit_card = {
    validate(value) {
        const cardNumber = value.replace(/[\s-]/g, '');
        const cardRegex = new RegExp('^[0-9]{16}$');
        if (!cardRegex.test(cardNumber)) return false;

        return luhnCheck(cardNumber);
    }
};

export {
    credit_card
}
